import { motion } from "framer-motion";
import { Flower2, CalendarCheck, UtensilsCrossed, Building2 } from "lucide-react";
import { Reveal } from "./Reveal";

const facilities = [
  { icon: Flower2, title: "Decoration", desc: "Floral artistry, stage fabrication, backdrops & thematic lighting." },
  { icon: CalendarCheck, title: "Event Management", desc: "End-to-end planning, guest management, transport & logistics." },
  { icon: UtensilsCrossed, title: "Catering", desc: "Arihant Caterers — premium pure-vegetarian menus & live counters." },
  { icon: Building2, title: "Venue Selection", desc: "Handpicked banquets, lawns & destination venues for every scale." },
];

export default function Facilities() {
  return (
    <section id="facilities" data-testid="facilities-section" className="bg-heirloom-bone py-20 md:py-24 border-t border-heirloom-line">
      <div className="max-w-[1300px] mx-auto px-6">
        <Reveal className="text-center mb-14">
          <span className="gold-rule overline text-heirloom-maroon">What We Provide</span>
          <h2 className="font-display text-4xl md:text-5xl text-heirloom-obsidian mt-4">
            Everything Under <span className="text-heirloom-maroon italic">One Roof</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {facilities.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={`facility-${i}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative text-center px-6 py-10 rounded-2xl border border-heirloom-line bg-heirloom-cream/50 hover:bg-heirloom-maroon transition-colors duration-500"
            >
              <span className="mx-auto mb-5 h-16 w-16 rounded-full bg-heirloom-maroon/10 text-heirloom-maroon flex items-center justify-center group-hover:bg-heirloom-gold group-hover:text-heirloom-maroon-deep transition-colors duration-500">
                <f.icon size={28} />
              </span>
              <h3 className="font-display text-2xl text-heirloom-obsidian group-hover:text-heirloom-bone transition-colors duration-500">{f.title}</h3>
              <p className="text-sm mt-3 leading-relaxed text-heirloom-obsidian/60 group-hover:text-heirloom-bone/80 transition-colors duration-500">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
